import { isOldCardDesign } from 'common/paymentCards/utils';

import { CreditCard } from '../../../../../hooks/useCreditCards';
import basicCardVerso from './assets/basicCardVerso.png';
import basicCardVersoOld from './assets/basicCardVersoOld.png';
import premiumCardVerso from './assets/premiumCardVerso.png';
import premiumCardVersoOld from './assets/premiumCardVersoOld.png';

export const getCardTokenAssetSrc = (creditCard: CreditCard) => {
  const { isPremium } = creditCard;

  const isOldDesign = isOldCardDesign(creditCard);
  const basicAssetSrc = isOldDesign ? basicCardVersoOld : basicCardVerso;
  const premiumAssetSrc = isOldDesign ? premiumCardVersoOld : premiumCardVerso;

  return isPremium ? premiumAssetSrc : basicAssetSrc;
};
